export const moduleName = "workspacesModule";
export const commentModuleName = "commentsModule";
